import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	verifiedIconDefaultTooltip: {
		id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
		defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
		description: 'Tooltip text for the verified team icon',
	},
});
